var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"digital_highway","data-bo-hw-lead-button":"hidden"}})
}
var staticRenderFns = []

export { render, staticRenderFns }